import React from 'react';
import {
  MathFormula20Regular,
  NumberSymbol20Regular,
  CalendarLtr20Regular,
  TextNumberListLtr20Regular,
} from '@fluentui/react-icons';
import type { FieldCategory } from './fieldUtils';

interface FieldCategoryIconProps {
  cat: FieldCategory;
  className: string;
}

/** Renders the appropriate icon for a field category. */
const FieldCategoryIcon: React.FC<FieldCategoryIconProps> = ({ cat, className }) => {
  switch (cat) {
    case 'measure': return <span className={className}><NumberSymbol20Regular /></span>;
    case 'date': return <span className={className}><CalendarLtr20Regular /></span>;
    case 'calculated': return <span className={className}><MathFormula20Regular /></span>;
    case 'dimension':
    default: return <span className={className}><TextNumberListLtr20Regular /></span>;
  }
};

export default FieldCategoryIcon;